import React, { useContext } from "react";

import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Functions from "../../utility/services/Functions";
import { AuthContext } from "../../utility/services/AuthContext";
import AOS from "aos";
import Gradient1IMG from "../images/newimg/gradient2.jpg";

const BannerSection = (props) => {
  //////////////////////////////////// LOGICAL VARIABLES ///////////////////////////////////////////////
  // LOGICAL VARIABLES
  React.useEffect(() => {
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);
  const { consoleService } = Functions();
  const { user } = useContext(AuthContext);

  const isUserDetails = user.details != null;
  const role = isUserDetails ? user.details.role : "";

  /////////////////////////////////////////// DATA VARIABLES //////////////////////////////////////////////

  const { title } = props;

  /////////////////////////////////////////// FUNCTIONS /////////////////////////////////////////////////

  const naviage_to = () => {
    if (isUserDetails) {
      if (role == "Therapist") {
        return "/dashboard";
      } else if (role == "Patient") {
        return "/dashboard";
      } else {
        return "/";
      }
    } else {
      return "/";
    }
  };

  return (
    <div
      className="breadcrumbmain_div"
      style={{ backgroundImage: `url(${Gradient1IMG})` }}
    >
      <div className="container">
        <div className="row">
          <div className="colxl-12 col-lg-12 col-md-12">
            <h1
              className="ft-medium fw-bold"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="50"
            >
              {props.title}
            </h1>
            {/* <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <Nav.Link
                  as={Link}
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  data-aos-delay="50"
                  to={naviage_to()}
                  className="breadcrumb-item active theme-cl"
                  aria-current="page"
                >
                  {props.name}
                </Nav.Link>
                {title != "Appointments" && (
                  <>
                    {" "}
                    <span className="slashbox">/</span>
                    <Nav.Link
                      data-aos="zoom-in"
                      data-aos-duration="1000"
                      data-aos-delay="50"
                      as={Link}
                      to=""
                      className="breadcrumb-item active theme-cl"
                      aria-current="page"
                    >
                      {props.title}
                    </Nav.Link>
                  </>
                )}
              </ol>
            </nav> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
